// components/features/categories/CategoryRow.tsx
import { Category } from "@cabukaka/types";
import TableRow from "../../ui/TableRow";
import { Tag, FolderOpen, Package } from "lucide-react";

interface CategoryRowProps {
  category: Category;
  onAction: (category: Category) => void;
  onSelect?: (category: Category, isSelected: boolean) => void;
  isSelected?: boolean;
  selectable?: boolean;
}

export default function CategoryRow({ 
  category, 
  onAction, 
  onSelect,
  isSelected = false,
  selectable = false
}: CategoryRowProps) {
  return (
    <TableRow
      item={category}
      onAction={onAction}
      onSelect={onSelect}
      isSelected={isSelected}
      selectable={selectable}
      actionable={true}
    >
      <td className="py-3 px-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center overflow-hidden flex-shrink-0">
            {category.image ? (
              <img src={category.image} alt={category.name} className="w-full h-full object-cover" />
            ) : (
              <Tag size={18} className="text-gray-400" />
            )}
          </div>
          <div>
            <span className="font-medium text-gray-800 block">
              {category.name}
            </span>
            {category.slug && (
              <span className="text-xs text-gray-400">/{category.slug}</span>
            )}
          </div>
        </div>
      </td>

      <td className="hidden sm:table-cell py-3 px-4">
        <div className="flex items-center gap-2">
          <FolderOpen size={14} className="text-gray-400" />
          <span className="text-gray-600">{category.sector?.name || '-'}</span>
        </div>
      </td>

      <td className="hidden md:table-cell py-3 px-4">
        <div className="flex items-center gap-2">
          <Package size={14} className="text-gray-400" />
          <span className="text-gray-600">{category.productCount || 0} produits</span>
        </div>
      </td>
    </TableRow>
  );
}